/* eslint-disable react/prop-types */
import React from "react";

/**
 * MyopiaRefractionChoiceModal lets the user pick which refraction reading
 * (objective or subjective) should drive the myopia report.
 * @param {Object} props - Component props
 * @param {Function} props.closePopup - Closes the modal
 * @param {Function} props.onSelect - Called with "objective" | "subjective"
 * @param {Boolean} props.subjectiveAvailable - Whether subjective refraction exists for this exam
 */
const MyopiaRefractionChoiceModal = ({
  closePopup,
  onSelect,
  subjectiveAvailable
}) => {
  return (
    <div className="custommodal">
      <div className="custommodalinner refraction-choice-modal">
        <div className="firstpage">
          <div className="hrpadding">
            <h4 className="modal-heading">Select Refraction Reading</h4>
            <button className="cancle" onClick={closePopup}>
              <span className="cross">✕</span>
            </button>
          </div>

          <div className="refraction-choice-content">
            <p className="refraction-choice-description">
              Choose which refraction reading to use for the myopia report.
            </p>

            <div className="refraction-choice-actions">
              <button
                type="button"
                className="loginbtn1 refraction-choice-btn"
                onClick={() => onSelect("objective")}
              >
                Objective Refraction
              </button>
              <button
                type="button"
                className="loginbtn1 refraction-choice-btn"
                onClick={() => onSelect("subjective")}
                disabled={!subjectiveAvailable}
              >
                Subjective Refraction
              </button>
            </div>

            {!subjectiveAvailable && (
              <p className="refraction-choice-note">
                To generate a report using subjective refraction, add subjective
                refraction values in the biometry table first.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyopiaRefractionChoiceModal;
